import { useQuery } from "react-query";
import { getAllOverridePaymentType } from "../../../../actions/CarrierAgreementMgmt/Agreements";

export const useGetAllOverridePaymentTypes = () => {
  return useQuery("getOverridePayments", getAllOverridePaymentType, {
    refetchOnWindowFocus: false,
  });
};
